// extracted by mini-css-extract-plugin
module.exports = {"game":"Game_game__F8voX","gameOver":"Game_gameOver__10NBm","quit":"Game_quit__TSw0a"};